export default {"src":"/_next/static/media/star.22a08261.svg","height":58,"width":41,"blurWidth":0,"blurHeight":0};